import { AxiosError } from 'axios';
import {
  GetReportsByIdResponseInfo,
  ApiResponseWithPaging,
  ReportsInfoRequest,
  UnNotifiedReportsResponse,
  MarkReportsAsNotified,
  MarkReportsAsNotifiedResponse,
} from '@dispatch/shared/types';
import {
  ExportReportRequest,
  ExportReportResponse,
} from '@dispatch/shared/types';
import { handleError } from '../resources/resource.service';
import { dispatchClient } from '../clients';
import { minutesToMilliseconds } from 'date-fns';
import { mapResponseWithPaging } from '../helpers/AxiosMappers';

const APIM_BASE_SERVICE_REPORT_SERVICE_URL = 'reports';
const APIM_SERVICE_EXPORT_TIMER_URL = `configuration/system/reportExportTimerInMinutes`;

export async function getReportExportTimerConfig() {
  try {
    const { data } = await dispatchClient.get<number>(
      APIM_SERVICE_EXPORT_TIMER_URL
    );
    return minutesToMilliseconds(data);
  } catch (e) {
    throw new Error(
      'error fetching report export timer configuration from API'
    );
  }
}

//to fetch all the reports for reports page by userID, expand = true
export const getReportsByUserID = async (
  request: ReportsInfoRequest,
  continuationToken?: string
): Promise<ApiResponseWithPaging<GetReportsByIdResponseInfo[]>> => {
  const response = await dispatchClient.post<GetReportsByIdResponseInfo[]>(
    `${APIM_BASE_SERVICE_REPORT_SERVICE_URL}`,
    { ...request },
    {
      params: {
        pageSize: request.filter.pageSize,
      },
      headers: {
        'Continuation-Token': continuationToken || '',
      },
    }
  );

  return mapResponseWithPaging(response);
};

//to create a new report - export task functionality
export const exportReportApi = async <TFilter>(
  payload: ExportReportRequest<TFilter>
) => {
  try {
    const response = await dispatchClient.post<ExportReportResponse>(
      `${APIM_BASE_SERVICE_REPORT_SERVICE_URL}/create`,
      payload
    );

    if (response.status === 201) {
      return { success: true };
    }

    return { success: false };
  } catch {
    return { success: false };
  }
};

//to get unnotied reports
export const fetchUnNotifiedReports = async (
  request: ReportsInfoRequest
): Promise<UnNotifiedReportsResponse[]> => {
  const { data } = await dispatchClient.post<UnNotifiedReportsResponse[]>(
    `${APIM_BASE_SERVICE_REPORT_SERVICE_URL}`,
    request
  );
  return data;
};

//to update status to isNotfied=true for unnotified reports
export const markReportsAsNotified = async (
  reportsToMark: MarkReportsAsNotified[]
): Promise<MarkReportsAsNotifiedResponse | void> => {
  try {
    const { data } = await dispatchClient.post<MarkReportsAsNotifiedResponse>(
      `${APIM_BASE_SERVICE_REPORT_SERVICE_URL}/update`,
      reportsToMark
    );
    return data;
  } catch (e) {
    return handleError(
      e as AxiosError | Error,
      'Updating status of reports failed.'
    );
  }
};
